module.exports = __webpack_public_path__ + "assets/img/e24e430e89e34dccfb462c4a8f7fe404.png";